/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { OpenShiftResponse } from './OpenShiftResponse';
import {
    OpenShiftResponseFromJSON,
    OpenShiftResponseFromJSONTyped,
    OpenShiftResponseToJSON,
    OpenShiftResponseToJSONTyped,
} from './OpenShiftResponse';

/**
 * 
 * @export
 * @interface SearchOpenShiftResponsesResponse
 */
export interface SearchOpenShiftResponsesResponse {
    /**
     * 
     * @type {Array<OpenShiftResponse>}
     * @memberof SearchOpenShiftResponsesResponse
     */
    data: Array<OpenShiftResponse>;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchOpenShiftResponsesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the SearchOpenShiftResponsesResponse interface.
 */
export function instanceOfSearchOpenShiftResponsesResponse(value: object): value is SearchOpenShiftResponsesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchOpenShiftResponsesResponseFromJSON(json: any): SearchOpenShiftResponsesResponse {
    return SearchOpenShiftResponsesResponseFromJSONTyped(json, false);
}

export function SearchOpenShiftResponsesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchOpenShiftResponsesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OpenShiftResponseFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function SearchOpenShiftResponsesResponseToJSON(json: any): SearchOpenShiftResponsesResponse {
      return SearchOpenShiftResponsesResponseToJSONTyped(json, false);
  }

  export function SearchOpenShiftResponsesResponseToJSONTyped(value?: SearchOpenShiftResponsesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OpenShiftResponseToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

